import dayjs from 'dayjs';

// Single source of truth for CSV export filenames. The Common Export service
// passes this `filename` to the worker, so the download name can't drift on
// prefix or date format across register types.
export function buildCsvExportFilename(prefix: string) {
  return `${prefix}-${dayjs().format('YYYY-MM-DD')}.csv`;
}
